import { useEffect, useState } from "react";
import Icon1 from "../../assets/icons/Icon";
import { useAuth } from "../../auth/FirebaseAuth";
import { useAppContext } from "../../config/AppContext";
import {
  getOrgDataById,
  getRefFromId,
  getUserDataById,
  queryCollection,
} from "../../models/DataFunctions";
import DataGridGPT2 from "../../tables/DataGridGPT2";
import TFGPT1 from "../../textfields/TFGPT1";
import { transformUsersToTable } from "./adminHelpers";
import Space from "../../layout/Space";

function Users({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);

  const [selected_users_list, setSelectedUsersList] = useState([]);

  const [users, setUsers] = useState([]);
  // Function to navigateWorkspace to a client by ID
  const gotoUser = (id) => {
    navigateWorkspace(`/admin/user/${id.id}`);
  };

  // Function to navigateWorkspace to a client by name
  const gotoUserEmail = (value) => {
    // Find the client with the matching name
    const user = rows.find((row) => row.email === value.value);

    // If client exists, navigateWorkspace to the client page by ID
    if (user) {
      navigateWorkspace(`/admin/user/${user.id}`);
    } else {
      console.error("User not found");
    }
  };

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserDataById(currentUser.uid);

      // Fetch organization data using the user's org reference
      const org = await getOrgDataById(user.org_id);

      // Fetch clients associated with the user's organization
      const users = await queryCollection("user", []);

      // Transform clients into table format (rows and columns)
      const { rows, columns } = transformUsersToTable(users);

      // Update state if the user data is new or changed
      if (user && user !== userData) {
        setUserData(user);
        setOrgData(org);
        setUsers(users);
        setRows(rows);
        setColumns(columns);

        let options_cleaned = users.map((user) => user.email);
        options_cleaned = options_cleaned.filter((user) => user !== undefined);

        // Set options for the search bar (client names)
        setOptions(
          users
            .filter((user) => user.email !== undefined)
            .map((user) => ({
              value: user.email,
              label: user.email + " " + user.display_name,
            }))
        );
      }
    }
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  const handleSelectionModelChange = (selection) => {
    setSelectedUsersList(selection);
  };

  // Render the client data
  return (
    <div className="h-full w-full max-h-full pl-4 flex-col pt-4 gap-2 flex ">
      <div className="h-fit w-full  flex flex-col gap-4">
        <div className="text-hx font-medium">Utilisateurs</div>

        <div className="bg-white border-1 border-shadow_25 rounded-full w-c500 flex flex-row gap-2 items-center px-2">
          <Icon1 icon_name="search" size={20} fill="grey"></Icon1>
          <TFGPT1
            options={options}
            placeholder="Chercher"
            inputValue={searchValue}
            setInputValue={setSearchValue}
            onAction={gotoUserEmail}
            className="w-full"
            start_only={false}
          ></TFGPT1>
        </div>

        <div className="w-full h-full max-h-[60%]  max-w-full mt-2">
          <DataGridGPT2
            show_ranking={true}
            rows={rows}
            columns={columns}
            onClick={gotoUser}
            initial_saved_columns_showed={{
              id: true,
            }}
            initial_sort_field="email"
            handleSelectionModelChange={handleSelectionModelChange}
          ></DataGridGPT2>{" "}
        </div>
      </div>
    </div>
  );
}

export default Users;
